<template>
  <div>
    
    <vs-card v-if="showCargoInformation">
      <h3>Kargo Bilgileri</h3>

      <b-row>
        <b-col cols="3">
          <b-form-group label="Pazaryeri" label-for="h-marketplace">
            <b-form-input
              size="sm"
              id="h-marketplace"
              v-model="CargoProgram"
              name="marketplace"
              v-focus 
              />
          </b-form-group>
        </b-col>
        <b-col cols="3">
          <b-form-group label="Kargo" label-for="h-cargo">
            <b-form-input
              size="sm"
              id="h-cargo"
              v-model="cargoProviderName"
              name="cargo"
            />
          </b-form-group>
        </b-col>
        <b-col cols="3">
          <b-form-group label="Tarih" label-for="islemTarihiCargo">
            <b-form-datepicker
              id="baslangic"
              v-model="transdate"
              size="sm"
              local="en"
              class="mb-2"
              today-variant="danger"
              placeholder="-"
              :date-format-options="{
                year: 'numeric',
                month: 'numeric',
                day: 'numeric'  
              }"          
            />
          </b-form-group>
        </b-col>
        <b-col cols="3">
          <b-form-group label="Sipariş No" label-for="h-orderNumber">
            <b-form-input
              size="sm"
              id="h-orderNumber"
              v-model="orderNumberCargo"
              name="orderNumber"
              @keyup.enter="validateStep1()"
              v-validate="'required'"
            />
            <span class="text-danger">{{ orderNumberError }}</span>
          </b-form-group>
          
        </b-col>
        <b-col cols="3">
          <b-form-group
            label="Kargo Takip Numarası"
            label-for="h-cargoTrackingNumber"
          >
            <b-form-input
              size="sm"
              id="h-cargoTrackingNumber"
              v-model="cargoTrackingNumber"
              name="cargoTrackingNumber"
            />
          </b-form-group>
        </b-col>
        <b-col cols="3">
          <b-form-group label="Ad Soyad" label-for="h-shipFullName">
            <b-form-input
              size="sm"
              id="h-shipFullName"
              v-model="CargoshipFullName"
              name="shipFullName"
            />
          </b-form-group>
        </b-col>
        <b-col cols="3">
          <b-form-group label="Şehir" label-for="h-shipCity">
            <b-form-input
              size="sm"
              id="h-shipCity"
              v-model="CargoShipCity"
              name="shipCity"
            />
          </b-form-group>
        </b-col>
        <b-col cols="3">
          <b-form-group label="İlçe" label-for="h-shipDistrict">
            <b-form-input
              size="sm"
              id="h-shipDistrict"
              v-model="CargoShipDistrict"
              name="shipDistrict"
            />
          </b-form-group>
        </b-col>
        <b-col cols="3">
          <b-form-group label="Tam Adres" label-for="h-shipFullAddress">
            <b-form-input
              size="sm"
              id="h-shipFullAddress"
              v-model="CargoShipFullAddress"
              name="shipFullAddress"
            />
          </b-form-group>
        </b-col>
      </b-row>
      <div slot="footer">
        <vs-row vs-justify="flex-end">
          <b-col>
            <vs-button type="gradient" color="success" id="loading-tesellum-gonder" class="vs-con-loading__container" icon="save" style="marg: inherit;margin-inline-start: auto;" radius   @click="validateStep1(); addCargo()"
            v-b-tooltip.hover.bottom="'Kaydet'"></vs-button> 
          </b-col>
        </vs-row>
        <b-row style="margin-top: 8px">
          <b-col cols="25">
            <hr style="border: 1px solid #ccc; margin-top: 10px;" />
          </b-col>
        </b-row>
      </div>
    </vs-card>

    <h3>Filtreleme</h3>
    <vs-card>
      <b-row class="align-items-center justify-content-center">
        <b-col class="text-inputx">
          <b-form-group label="Sipariş No" label-for="item-name">
            <b-form-input
              size="sm"
              ref="orderNumberCargo"
              class="inputx"
              placeholder="Arama..."
              v-model="aranan1"
              @keyup.enter="getkargoGonderiTutanakListe()"
            />
          </b-form-group>
        </b-col>
        <b-col class="text-inputx">
          <b-form-group label="Başlangıç Tarihi" label-for="item-name">
            <b-form-datepicker
              id="datepicker"
              v-model="cargotransdate"
              size="sm"
              local="en"
              class="mb-2"
              today-variant="danger"
              placeholder="-"
              :date-format-options="{
                year: 'numeric',
                month: 'numeric',
                day: 'numeric'
              }"
              @keydown.native.prevent="clearDate"
            />
          </b-form-group>
        </b-col>
        <b-col class="text-center">
          <vs-button type="gradient" color="success" class="vs-con-loading__container"
          icon="search" radius @click="getkargoGonderiTutanakListe()" v-b-tooltip.hover.bottom="'Arama'"
          ></vs-button>
        </b-col>
        <b-col class="text-center">
          <vs-button type="gradient" color="success" icon="send" @click="toggleCargoInformation" size="md">Yeni kargo ekle</vs-button>
        </b-col>
      </b-row>
    </vs-card>
    
    
    <vs-card>
      <b-row>
        <b-col>
          <vs-button  type="gradient" color="success"  icon="print" 
           radius @click="yazdir()"  v-b-tooltip.hover.bottom="'Yazdır'"></vs-button>
        </b-col>
        <b-col cols="12">
          <ag-grid-vue
            style="width: 100%; height: 400px; margin-top: 25px"
            class="ag-theme-alpine"
            :defaultColDef="defaultColDef"
            :columnDefs="columnDefs"
            @filterChanged="onFilterChanged"
            :rowData="kargoGonderiTutanakListe"
          >
          </ag-grid-vue>
        </b-col>
      </b-row>
    </vs-card>
    <kargoGenelYazdir
  :kargoGonderiTutanakListePr="filteredRows.length == 0 ? kargoGonderiTutanakListe : filteredRows"
  ref="yazdir"
/>

  </div>
</template>
<script>
import moment from "moment";
import Datepicker from "vuejs-datepicker";
import { AgGridVue } from "ag-grid-vue";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import "ag-grid-enterprise";
import vSelect from "vue-select";
import state from "../../store/state";
import Store from "../../store/store";
import kargoTesellumButon from "../components/uzum-components/pazaryeri-components/kargoTesellumButon.vue";
import kargoGorevEkle from "../components/uzum-components/pazaryeri-components/kargoGorevEkle.vue";
import kargoGenelYazdir from "../components/uzum-components/pazaryeri-components/kargoGenelYazdir.vue";
import { Validator } from "vee-validate";
const dict = {

  custom: {
    orderNumberCargo: {
      required: "Sipariş numarası gereklidir",
    },
 
  }
};
export default {
  directives: {
    focus: {
      inserted: function (el) {
        el.focus()
      },
    },
  },

  data() {
    return {
      defaultColDef: {
        sortable: true,
        resizable: true
      },
      columnDefs: null,
      orderNumberError: null,
      onSelectionChangedCargo: [],
      onSelectionChangedMasraf: [],
      columnDefs: [],
      gorevliste: [],
      cargoList: [],
      cargoTrackingNumber: "",
      kargoGonderiTutanakListe: [],
      aranan1: "",
      showCargoInformation: false,
      aranan: "",
      Cargoid: "",
      tarihDegeri: "",
      orderNumberCargo: "",
      CargoShipCity: "",
      CargoshipFullName: "",
      CargoShipDistrict: "",
      CargoShipFullAddress: "",
      CargoProgram: "",
      CargoReceiptno: "",
      islemTarihiCargo: "",
      transdate: "",
      cargotransdate: "",
      filteredRows: [],
      CargoDeliveryarea: "",
      cargoProviderName: ""
    };
  },

  methods: {
  onFilterChanged(params) {
    const displayedRowCount = params.api.getDisplayedRowCount();

  this.filteredRows = [];
    for (let i = 0; i < displayedRowCount; i++) {
      const displayedRowNode = params.api.getDisplayedRowAtIndex(i);
      this.filteredRows.push(displayedRowNode.data);
    }

  },

    validateStep1() {
  this.$validator.validateAll("step-1").then((result) => {
    if (result) {
      if (!this.orderNumberCargo) {
        this.orderNumberError = "Sipariş numarası gereklidir";
      } else {
        this.orderNumberError = null;
        this.onSubmit();
      }
    } else {
      this.orderNumberError = "Lütfen tüm değerleri doğru girin";
    }
  });
},

    toggleCargoInformation() {
      this.showCargoInformation = !this.showCargoInformation;
      
    },
    yazdir() {
      this.$refs.yazdir.yazdir();
        },
        clearDate(event) {
          if (event.keyCode === 46 || event.keyCode === 8) { 
        this.cargotransdate = null;
    }


    },
   // getkargoGuncelle(gelen) {
     // if (typeof gelen != "undefined") {
       // this.Cargoid =gelen.ıd;
       // this.orderNumberCargo =    gelen.orderNumber;
       // this.CargoDeliveryarea =   deliveryarea;
       // this.CargoProgram =   program ;
       // moment(this.transdate).format("DD.MM.YYYY") =   gelen.transdate; 
       // this.CargoReceiptno =   receiptno;
       // this.cargoProviderName =  cargoProviderName;
       // this.cargoTrackingNumber =   cargoTrackingNumber;
        //this.CargoshipFullName =    shipFullName;
        //this.CargoShipDistrict =  shipDistrict;
        //this.CargoShipCity =   shipCity;
        //this.CargoShipFullAddress =   shipFullAddress;
      //}
   // },
    getNow: function() {
      const today = new Date();
      const date =
        today.getDate() +
        "-" +
        (today.getMonth() + 1) +
        "-" +
        today.getFullYear();
      const time =
        today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();
      const dateTime = date + " " + time;
      return dateTime;
    },

    // updateTransdate() {
    // if (this.transdate) {
    // this.transdate = moment(this.transdate, 'DD.MM.YYYY').toDate();
    // }
    //},
   

    addCargo() {
      console.log(this.transdate);
      if (this.orderNumberCargo !== "") {
        const args = {
          Id: this.Cargoid,
          orderNumber: this.orderNumberCargo,
          deliveryarea: this.CargoDeliveryarea,
          program: this.CargoProgram,
          transdate: moment(this.transdate).format("DD.MM.YYYY"),
          receiptno: this.CargoReceiptno,
          cargoProviderName: this.cargoProviderName,
          cargoTrackingNumber: this.cargoTrackingNumber,
          shipFullName: this.CargoshipFullName,
          shipDistrict: this.CargoShipDistrict,
          shipCity: this.CargoShipCity,
          shipFullAddress: this.CargoShipFullAddress
        };

        console.log(args);
        const vm = this;
        const soap = require("soap");
        const url = state.sistemAddress;

        soap.createClient(url, function(err, client) {
          client.kargoGonderiTutanak(args, function(err, result) {
            vm.veriler = JSON.parse(result.kargoGonderiTutanakResult);
            vm.kargoGonderiTutanak = vm.veriler.jsonData;

            vm.getkargoGonderiTutanakListe();
          });
        });
      }
    },

    getkargoGonderiTutanakListe() {
      const vm = this;
      const soap = require("soap");
      const url = state.sistemAddress;
 

      let args = {
        orderNumber: vm.aranan1,
        date:moment(String(vm.cargotransdate)).format("DD.MM.YYYY") 
        //  date: nullmoment(String(vm.tarihDegeri)).format("DD.MM.YYYY"),
      };
      if (vm.cargotransdate == "") {
        args = {
          orderNumber: vm.aranan1
          //  date: nullmoment(String(vm.tarihDegeri)).format("DD.MM.YYYY"),
        };
      }
      console.log(args);
      const startDate = "2023-10-01";
      const endDate = "2023-10-31";
      soap.createClient(url, function(err, client) {
        if (err) {
          console.error("SOAP client oluşturulurken hata oluştu:", err);
          return;
        }

        client.kargoGonderiTutanakListe(args, function(err, result) {
          if (err) {
            console.error(
              "Kargo gönderi tutanak listesi alınırken hata oluştu:",
              err
            );
            return;
          }

          if (result.kargoGonderiTutanakListeResult == "-1") {
            Store.dispatch("logout");
          }
 
          
          vm.veriler = JSON.parse(result.kargoGonderiTutanakListeResult);
          vm.kargoGonderiTutanakListe = vm.veriler.jsonData;
          
                   
        

          console.log(
            "kargoGonderiTutanakListe güncellendi: ",
            vm.kargoGonderiTutanakListe
          
          );
        });
      });
    },

    //birinci yol
    kargoGonderiTutanakListeFunc() {
      const vm = this;
      const soap = require("soap");
      const url = state.sistemAddress;

      soap.createClient(url, function(err, client) {
        if (err) {
          console.error("SOAP client oluşturulurken hata oluştu:", err);
          return;
        }

        client.kargoGonderiTutanakListe({}, function(err, result) {
          if (err) {
            console.error(
              "Kargo gönderi tutanak listesi alınırken hata oluştu:",
              err
            );
            return;
          }

          if (result.kargoGonderiTutanakListeResult == "-1") {
            Store.dispatch("logout");
          }

          vm.veriler = JSON.parse(result.kargoGonderiTutanakListeResult);

          console.log(vm.veriler);
          let filtrelenmisVeriler = vm.veriler.jsonData;

          // Sipariş numarasına göre filtreleme
          if (vm.aranan1) {
            filtrelenmisVeriler = filtrelenmisVeriler.filter(veri => {
              return veri.orderNumber.includes(vm.aranan1);
            });
            console.log(filtrelenmisVeriler);
          }
          vm.kargoGonderiTutanakListe = filtrelenmisVeriler;

          // Tarihe göre filtreleme
          // if (vm.transdate) {
          //     filtrelenmisVeriler = filtrelenmisVeriler.filter(veri => {
          //       const tarih = moment(veri.tarih, 'DD.MM.YYYY'); // Veri tarihini "DD.MM.YYYY" formatına dönüştür
          //       const filtreTarih = moment(vm.transdate, 'DD.MM.YYYY'); // Filtre tarihini "DD.MM.YYYY" formatına dönüştür

          //        return tarih.isSame(filtreTarih, 'DD.MM.YYYY'); // Tarihleri karşılaştır
          //    });
          //    }

          vm.kargoGonderiTutanakListe = filtrelenmisVeriler;
          console.log(
            "kargoGonderiTutanakListe güncellendi: ",
            vm.kargoGonderiTutanakListe
          );
        });
      });
    }
  },
  // watch: {
  // transdate: {
  //  handler: 'updateTransdate',
  // },
  //},
  components: {
    Datepicker,
    kargoGorevEkle,
    kargoTesellumButon,
    kargoGenelYazdir,
    AgGridVue,
    "v-select": vSelect,
},
  created() {
    this.getkargoGonderiTutanakListe();
  },
  mounted() {
  
    this.$root.$on("kargoGorevListe", () => {
    this.getkargoGonderiTutanakListe();
    });
    
    this.$root.$on("kargoGuncelle", () => {
      this.getkargoGonderiTutanakListe();
    });
  },
  beforeDestroy() {
    this.$root.$off("kargoGorevListe");
    this.$root.$off("kargoGuncelle");

  },
  
  beforeMount() {
    this.columnDefs = [
      {
        width: 200,
        field: "Silme İşlemi",
        cellRendererFramework: "kargoGorevEkle",
        autoHeight: true
      },
      {
        headerName: "Tarih",
        field: "transdate",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: {
          buttons: ["apply", "reset"],
          closeOnApply: true
        },
        cellRenderer: function(params) {
          if (params.value) {
            return moment(params.value).format("DD.MM.YYYY"); // Göstermek istediğiniz tarih formatı
          }
          return "";
        }
      },

      {
        headerName: "Fatura No",
        field: "receiptno",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true }
      },
      {
        headerName: "Sipariş No",
        field: "orderNumber",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true }
      },
      {
        headerName: "Pazaryeri",
        field: "program",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true }
      },
      {
        headerName: "Kargo Adı",
        field: "cargoProviderName",
        sortable: true,
        filter: "agSetColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true }
      },
      {
        headerName: "Kargo Takip Numarası",
        field: "cargoTrackingNumber",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true }
      },
      {
        headerName: "Teslimat İli",
        field: "shipCity",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true }
      },
      {
        headerName: "Teslimat İlçesi",
        field: "shipDistrict",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true }
      },
      {
        headerName: "Teslimat Adresi",
        field: "shipFullAddress",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true }
      },
      {
        headerName: "Teslimat Adı",
        field: "shipFullName",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true }
      },
     
      {
        headerName: "Teslimat Yeri",
        field: "deliveryarea",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true }
      }
    ];
  }
};
</script>
